module.exports = __webpack_public_path__ + "static/media/co_deportes.22824c96.png";